module.exports = __webpack_public_path__ + "img/bm-b.1c13d58a.png";